import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["navMarker", "errorMarker", "title", "description", "use", "showDescription", "displayFullCardsOnMobile", "appearsIn", "showOverview", "showPagination", "size", "onItemClick"];
import { useCallback, useState } from 'react';
import { CardsSection } from '../../cardsSection/components/CardsSection';
import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
import { useAiRecommendationsForLearningContent } from '../../academyAi';
import getLang from 'academy-common-lib/utils/getLang';
import { jsx as _jsx } from "react/jsx-runtime";
const useRecommendationsForLearningContent = (item, maxCards, offset) => {
  const {
    recommendations,
    recommendationsLoading,
    recommendationsError,
    hasMore,
    nextOffset,
    correlationId
  } = useAiRecommendationsForLearningContent({
    item,
    size: maxCards,
    skip: !maxCards,
    offset
  });

  // retrieves hydrated card models for the elements to render
  const {
    cardModels,
    cardModelsError,
    cardModelsLoading
  } = useLearningContentCardModels({
    items: (recommendations === null || recommendations === void 0 ? void 0 : recommendations.map(({
      recommendationId,
      recommendationType,
      language,
      resultMLOptionId
    }) => {
      return {
        id: recommendationId,
        type: recommendationType,
        language: language || getLang(),
        resultMLOptionId
      };
    })) || [],
    skip: !(recommendations !== null && recommendations !== void 0 && recommendations.length)
  });
  return {
    content: cardModels,
    loading: recommendationsLoading || cardModelsLoading || maxCards === undefined,
    error: recommendationsError || cardModelsError,
    hasMore,
    nextOffset,
    correlationId
  };
};
export const RecommendationsForLearningContent = _ref => {
  let {
      navMarker,
      errorMarker,
      title,
      description,
      use,
      showDescription,
      displayFullCardsOnMobile,
      appearsIn,
      showOverview,
      showPagination = true,
      size = 'large',
      onItemClick
    } = _ref,
    item = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [maxCards, setMaxCards] = useState();
  const [offset, setOffset] = useState('');
  const [previousOffsets, setPreviousOffsets] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const {
    content,
    loading: recommendationsLoading,
    error: recommendationsError,
    nextOffset,
    hasMore,
    correlationId
  } = useRecommendationsForLearningContent(item, maxCards, offset);
  const previousOffset = previousOffsets[currentPage - 1];
  const handleClickNext = useCallback(() => {
    if (previousOffsets.length <= currentPage) setPreviousOffsets(state => [...state, offset]);
    setOffset(nextOffset || '');
    setCurrentPage(cp => cp + 1);
  }, [currentPage, nextOffset, offset, previousOffsets.length]);
  const handleClickPrevious = useCallback(() => {
    setOffset(previousOffset);
    setCurrentPage(cp => cp - 1);
  }, [previousOffset]);
  return /*#__PURE__*/_jsx(CardsSection, {
    appearsIn: appearsIn || 'recommendations-for-entity',
    content: content,
    description: description,
    displayFullCardsOnMobile: displayFullCardsOnMobile,
    error: recommendationsError,
    errorMarker: errorMarker,
    header: title,
    isLoading: recommendationsLoading,
    navMarker: navMarker,
    onClickNext: handleClickNext,
    onClickPrevious: handleClickPrevious,
    onItemClick: (cardModel, index) => onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(cardModel, index, correlationId),
    setMaxCards: setMaxCards,
    showDescription: showDescription,
    showNext: showPagination && hasMore && !!nextOffset,
    showOverview: showOverview,
    showPrevious: showPagination && currentPage > 0,
    size: size,
    use: use
  });
};